import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Job } from "@/types";

export function useGetTargetJob({
  companyId,
  jobId,
}: {
  companyId?: string;
  jobId?: string;
}) {
  const canFetch = Boolean(companyId) && Boolean(jobId);

  return useQuery({
    queryKey: ["job", companyId, jobId],
    queryFn: async () => {
      if (!companyId || !jobId) {
        throw new Error("Missing companyId or jobId");
      }
      const path = `companies/${companyId}/jobs/${jobId}`;
      const res = await guacHttpClient.get<Job, HttpResponse<Job>>(path);
      return res.data;
    },
    enabled: canFetch,
  });
}
